// SA-3
export function productionWorkerActiveLabel(active: boolean): string {
  return active ? 'Активен' : 'Неактивен'
}

/** Должности с графиком 5/2 (будни, не ротация 2/2). */
export const POSITIONS_SHIFT_5_2 = [
  'Подсобный рабочий',
  'Руководитель отдела снабжения',
  'Контролер ОТК',
  'Заведующий производством',
] as const

export function isPositionShift5_2(position: string): boolean {
  const key = position.trim()
  return (POSITIONS_SHIFT_5_2 as readonly string[]).includes(key)
}

/** Должности, для которых при явке обязателен станок. */
export const POSITIONS_REQUIRE_MACHINE = ['Оператор', 'Намотчик'] as const

export function positionRequiresMachine(position: string): boolean {
  const key = position.trim()
  return (POSITIONS_REQUIRE_MACHINE as readonly string[]).includes(key)
}

/** Канонические должности цеха (для datalist и сида). */
export const PRODUCTION_POSITION_OPTIONS = [
  'Подсобный рабочий',
  'Намотчик',
  'Мастер',
  'Фасовщица-упаковщица',
  'Упаковщица',
  'Оператор',
  'Контролер ОТК',
  'Механик (наладчик)',
  'Заведующий производством',
  'Руководитель отдела снабжения',
] as const

/** Должность → slug системной роли при выдаче входа. */
export const JOB_TITLE_TO_ROLE: Record<string, string> = {
  'Подсобный рабочий': 'helper',
  Намотчик: 'winder',
  Мастер: 'shift_master',
  'Фасовщица-упаковщица': 'packer',
  Упаковщица: 'packer',
  Оператор: 'operator',
  'Контролер ОТК': 'qc_controller',
  'Механик (наладчик)': 'mechanic',
  'Заведующий производством': 'production_head',
  'Руководитель отдела снабжения': 'supply_head',
}

export function positionToRoleName(position: string): string | undefined {
  const key = position.trim()
  if (!key) return undefined
  return JOB_TITLE_TO_ROLE[key]
}

export function formatProductionWorkerContacts(row: {
  phone?: string
  email?: string
}): string {
  const parts: string[] = []
  if (row.phone?.trim()) parts.push(row.phone.trim())
  if (row.email?.trim()) parts.push(row.email.trim())
  return parts.length > 0 ? parts.join(' · ') : '—'
}
